import styled from "styled-components";
import { DELAYED_SUCCESS_CONSTANTS } from "./constant";

export const ContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: theme.spacing.large,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
}));

export const LoaderContainer = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.x4,
}));

export const TitleContainer = styled.div(() => ({
    textAlign: "center",
}));

export const SubtitleContainer = styled.div(({ theme }) => ({
    textAlign: "center",
    marginTop: theme.spacing.xSmall,
    width: DELAYED_SUCCESS_CONSTANTS.SUBTITLE_WIDTH,
    marginBottom: theme.spacing.xxLarge,
}));
